export const steps = {
  MFA_DEVICE_CREATE: 0,
  MFA_DEVICE_ACTIVATE: 1,
};
